/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { HousingFinderInput } from '../models/HousingFinderInput';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class FinderInputService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Get the finder input for a user's application by the application's id.
     * @param housingApplicationGuid The id of the application.
     * @param getOriginalInputs If true, return the original inputs. If false, return the override inputs.
     * @returns HousingFinderInput OK
     * @throws ApiError
     */
    public getFinderInputForHousingApplication(
        housingApplicationGuid: string,
        getOriginalInputs: boolean = false,
    ): CancelablePromise<HousingFinderInput> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/housing/FinderInput/{housingApplicationGuid}/{getOriginalInputs}/GetFinderInputForHousingApplication',
            path: {
                'housingApplicationGuid': housingApplicationGuid,
                'getOriginalInputs': getOriginalInputs,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Create a new finderInput or return the existing one.
     * @param requestBody The new finderInput.
     * @returns HousingFinderInput OK
     * @throws ApiError
     */
    public createFinderInput(
        requestBody?: HousingFinderInput,
    ): CancelablePromise<HousingFinderInput> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/housing/FinderInput/CreateFinderInput',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Update a row of finder input by their GUID.
     * @param requestBody The updates finderInput.
     * @returns HousingFinderInput OK
     * @throws ApiError
     */
    public updateFinderInput(
        requestBody?: HousingFinderInput,
    ): CancelablePromise<HousingFinderInput> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/api/housing/FinderInput/UpdateFinderInput',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Backfill legacy Accessible and Pets boolean filters into BuildingAttributes.
     * Looks up the "Accessible Housing" and "Pets (Legacy)" tree nodes by name,
     * then adds their GUIDs to BuildingAttributes for any HousingFinderInput where
     * the corresponding boolean is true. Safe to re-run.
     * @returns any OK
     * @throws ApiError
     */
    public backfillLegacyFilters(): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/housing/FinderInput/BackfillLegacyFilters',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Tags legacy Accessible data: for every HousingFinderInput where Accessible = true,
     * adds the "Accessible Housing (Legacy)" building attribute. Keeps the existing
     * Accessible flag and "Accessible Housing" attribute intact so applicants remain
     * matched to scenarios. HMB staff can then review and confirm whether the applicant
     * actually needs an accessible suite. Safe to re-run.
     * @returns any OK
     * @throws ApiError
     */
    public backfillAccessibleLegacyAttribute(): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/housing/FinderInput/BackfillAccessibleLegacyAttribute',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Finds all HousingSiteDetails with "Accessible" in the code, looks up which sites
     * have those details via the join table, and ensures those sites have the
     * "Accessible Housing" building attribute. Safe to re-run.
     * @returns any OK
     * @throws ApiError
     */
    public backfillAccessibleBuildingAttribute(): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/housing/FinderInput/BackfillAccessibleBuildingAttribute',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Finds all HousingSiteDetails with codes starting with "PF" or "Pet",
     * looks up which sites have those details, and ensures those sites have the
     * "Pets (Legacy)" building attribute. Safe to re-run.
     * @returns any OK
     * @throws ApiError
     */
    public backfillPetsBuildingAttribute(): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/housing/FinderInput/BackfillPetsBuildingAttribute',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
}
